export default function KpiCard({ label, value, sublabel, icon: Icon, accent = "blue", testId }) {
  const accentMap = {
    blue: "text-[#004a99] bg-[#e6f0ff]",
    orange: "text-[#f37021] bg-[#ffefe6]",
    green: "text-emerald-700 bg-emerald-50",
    slate: "text-slate-700 bg-slate-100",
  };
  return (
    <div
      className="tilt-card card-3d glass-panel shadow-3d rounded-2xl p-6 fade-up flex flex-col gap-3"
      data-testid={testId}
    >
      <div className="flex items-center justify-between">
        <div className="tiny-label">{label}</div>
        {Icon && (
          <div className={`icon-3d icon-float h-10 w-10 rounded-xl flex items-center justify-center ${accentMap[accent]}`}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
      <div className="kpi-number text-4xl text-slate-900 count-up" key={value}>{value}</div>
      {sublabel && <div className="text-sm text-slate-500">{sublabel}</div>}
    </div>
  );
}
